
const stringToHTML = string => {
	const doc = new DOMParser().parseFromString(string, "text/html");
	return doc.body.firstChild;
};

export default stringToHTML;